import {create} from 'zustand';
import { doctorsData } from '../api_layer.js/api';



const useDoctorsStore = create((set) => ({
    doctorsData: [],
    doctorsLoading:false,
    error:null,
    fetchDoctorsData: async (sd, ed) => {
      try {
        set({ doctorsLoading: true, error: null });
        const response = await doctorsData(sd, ed);
        set({ doctorsData: response.data, doctorsLoading: false });
      } catch (error) {
        set({ error: error.message, doctorsLoading: false });
      }
    },
}))

export default useDoctorsStore;